import { render, staticRenderFns } from "./ProgramStats.vue?vue&type=template&id=a5037406&scoped=true&lang=pug&"
import script from "./ProgramStats.vue?vue&type=script&lang=js&"
export * from "./ProgramStats.vue?vue&type=script&lang=js&"
import style0 from "./ProgramStats.vue?vue&type=style&index=0&id=a5037406&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5037406",
  null
  
)

export default component.exports